import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions/organisationActions';
import { X, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { delay } from '../utils/GlobalFunctions';

const SubscriptionEnded = ({ setShowPaymentModal, remindSubscriptionOwner }) => {
  const [loading, setLoading] = useState(false);
  const [reminderSent, setReminderSent] = useState(false);

  return (
    <div className='modal' style={{ display: 'block', background: 'rgba(0,0,0,.8)', height: '100vh' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          maxHeight: '90vh',
          maxWidth: '800px',
          margin: '0 auto',
        }}>
        <div className='modal-content'>
          <div className='modal-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h4 className='modal-title' style={{ textAlign: 'left' }}>
              Subscription Expired
            </h4>
            <button className='modal-close' onClick={() => setShowPaymentModal(null)}>
              <X size={16} strokeWidth={1.5} />
            </button>
          </div>
          <div className='modal-body'>
            <p>
              This organisation's subscription has ended.
              <br />
              The organisation owner has been informed, but you may send them a reminder if necessary.
            </p>
          </div>
          <div className='modal-footer'>
            <Button
              className='w-44'
              disabled={reminderSent || loading}
              onClick={async () => {
                setLoading(true);
                await remindSubscriptionOwner();
                setLoading(false);
                setReminderSent(true);
                delay(1000).then(() => {
                  setShowPaymentModal(null);
                });
              }}>
              {!reminderSent && (loading ? <Loader2 size={16} strokeWidth={1.5} className="animate-spin w-4" /> : 'Send a Reminder')}
              {reminderSent && 'Reminder Sent!'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  remindSubscriptionOwner: () => dispatch(Actions.remindSubscriptionOwner()),
});
const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionEnded);
